import { connect } from 'react-redux';
import theme from '../../../theme-config';
import I18n from '../../../lib/i18n';
import RedirectToIdentityRequirementOrDashboard from './RedirectToIdentityRequirementOrDashboard';
import { isLoggedInSelector } from '../../../modules/Authentication';

const mapStateToProps = state => ({
  title: I18n.t('SignUp.RedirectToIdentityRequirementOrDashboard.title'),
  subtitle: I18n.t('SignUp.RedirectToIdentityRequirementOrDashboard.subTitle'),
  image: theme.orderFailedImage,
  text: I18n.t('SignUp.RedirectToIdentityRequirementOrDashboard.text'),
  confirmButtonText: I18n.t('SignUp.RedirectToIdentityRequirementOrDashboard.confirmButton'),
  redirectTo: isLoggedInSelector(state) ? 'dashboard' : 'requiredToSignUp',
});

export default connect(mapStateToProps)(RedirectToIdentityRequirementOrDashboard);
